export default __webpack_public_path__ + "static/media/payment-image-01.1b28f1e5.png";